import React from 'react';
import DetailedTable from '../../components/DetailedTable';
import providerColumns from './providerColumns';

interface ServiceParticipantProps {
  providerData: providerInfo;
}

type providerInfo = {
  [key: string]: any;
};
const ServiceParticipantProvider = (props: ServiceParticipantProps) => {
  return (
    <DetailedTable
      id="ServiceParticipantProvider"
      title=""
      columns={providerColumns}
      data={props.providerData.providerInfo || []}
      showSelection={false}
      showPagination={true}
      page={0}
      rowsPerPage={10}
      tableActions={[]}
    />
  );
};

export default ServiceParticipantProvider;
